<p>
  Uses a number of charges of the given counter, and displays the remaining amount and delta.
  <avr-autodoc-link anchor="use-counter"></avr-autodoc-link>
</p>

<!-- counter type -->
<div class="auto-row">
  <span>Use {{counterType === 'ability' ? 'an' : 'a'}} </span>

  <mat-form-field>
    <mat-label>Counter Type</mat-label>
    <mat-select [(value)]="counterType" (selectionChange)="changed.emit(); onCounterTypeChange()">
      <mat-option value="ability">ability</mat-option>
      <mat-option value="counter">custom counter</mat-option>
      <mat-option value="slot">spell slot</mat-option>
    </mat-select>
  </mat-form-field>

  <span [ngSwitch]="counterType">
    <span *ngSwitchDefault>
      <span> named </span>
      <mat-form-field>
        <input matInput placeholder="Counter Name" (change)="changed.emit()" [(ngModel)]="effect.counter" required>
      </mat-form-field>
    </span>

    <span *ngSwitchCase="'slot'">
      <span> of level </span>
      <mat-form-field>
        <input matInput
               placeholder="Slot Level"
               class="text-monospace"
               (change)="changed.emit()"
               [(ngModel)]="effect.counter.slot"
               required>
        <mat-icon matSuffix
                  matTooltip="IntExpression - variables and functions allowed">
          calculate
        </mat-icon>
      </mat-form-field>
    </span>

    <span *ngSwitchCase="'ability'">
      <span> named </span>
      <mat-form-field
        matTooltip="When you run this action, I'll find the best counter to use for this ability automatically.">
        <mat-select [value]="selectedLimitedUse" (selectionChange)="onAbilitySelectionChange($event)">
          <mat-option>
            <ngx-mat-select-search placeholderLabel="Search"
                                   noEntriesFoundLabel="No matches found."
                                   ngModel (ngModelChange)="updateSearchFilteredGroupedLimitedUse($event)">
            </ngx-mat-select-search>
          </mat-option>
          <mat-optgroup *ngFor="let tup of searchFilteredGroupedLimitedUse" [label]="tup[0]">
            <mat-option *ngFor="let limitedUse of tup[1]" [value]="limitedUse">
              {{limitedUse.name}}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </span>
  </span>
</div>

<!-- amount -->
<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left center" class="auto-row">
  <mat-form-field fxFlex="grow">
    <input matInput
           placeholder="Amount"
           class="text-monospace"
           (change)="changed.emit()"
           [(ngModel)]="effect.amount"
           required
           matTooltip="If negative, will add charges instead of using them">
    <mat-icon matSuffix matTooltip="IntExpression - variables and functions allowed">
      calculate
    </mat-icon>
  </mat-form-field>
</div>

<!-- options -->
<span class="auto-label">Additional Options</span>
<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left baseline" class="auto-row">
  <mat-checkbox [(ngModel)]="effect.allowOverflow" (change)="changed.emit()">
    Allow Overflow
  </mat-checkbox>

  <span>|</span>

  <mat-checkbox [(ngModel)]="effect.fixedValue"
                (change)="changed.emit()"
                matTooltip="If checked, the counter will ignore the -amt argument.">
    Fixed Value
  </mat-checkbox>

  <span>|</span>

  <mat-form-field>
    <mat-label>Error Behaviour</mat-label>
    <mat-select [(value)]="errorBehaviourWrapper" (selectionChange)="changed.emit()">
      <mat-option value="ignore">Ignore</mat-option>
      <mat-option value="warn">Show Warning</mat-option>
      <mat-option value="raise">Stop Execution</mat-option>
    </mat-select>
  </mat-form-field>
</div>
